// react-table depends on spreading props; we could name them explicitly but this component might
// break if the shape of the return value from row.getRowProps() changes
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Cell, Row } from 'react-table';

import { IconMusicNotes, Tooltip } from '@trqk/components';

import { getSubRowMatchData } from '../../utils';
import { StatementWorkCell } from '.';
import { summarizeRowsAbove } from '../../constants';

interface AggregatedStatementWorkCellProps {
    cell: Cell<TrqkGapChannelAudio, GapWorkStatementWorkCellValue>;
    column: StatementWorkColumn;
    row: Row<TrqkGapChannelAudio>;
}

/**
 * For summary rows, this component displays the title of the matched statement work.
 * For non-summary rows, this component displays a <StatementWorkCell />.
 */
export function AggregatedStatementWorkCell({
    cell,
    column,
    row,
}: AggregatedStatementWorkCellProps): JSX.Element {
    const { matchCount, matchedWorkTitle } = getSubRowMatchData(row.subRows);
    const width = (column?.width as number) ?? 100;

    if (matchCount > summarizeRowsAbove) {
        return (
            <Tooltip
                message={matchedWorkTitle}
                position="bottom"
                minWidth={width}
                maxWidth={width}
            >
                <div className="pl-1 flex items-center" style={{ width }}>
                    <IconMusicNotes
                        addClasses="flex-none"
                        fillColor="primary-500"
                    />
                    <p className="px-1 font-semibold text-sm truncate">
                        {matchedWorkTitle}
                    </p>
                </div>
            </Tooltip>
        );
    }

    return <StatementWorkCell cell={cell} column={column} row={row} />;
}
